import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";

const TestTextMessageModal = ({ show, onClose, onSave, selectedRowDetails}) => {
  const [form, setForm] = useState({
    device_id : "",
    fromMobile : "",
    toMobile : "",
    text_message : "",
  });

  useEffect(() => {
    console.log(selectedRowDetails);
    const fetchData = async () => {
      console.log(selectedRowDetails);
      setForm({
        device_id: selectedRowDetails.device_id,
        fromMobile : selectedRowDetails.mobile,
        toMobile : "",
        text_message : "",
      });
    };
    fetchData();
  }, [selectedRowDetails, show]);

  const [validated, setValidated] = useState(false);

  const [ error, setError ] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;

    if (formElement.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    onSave(form);
    onClose();
  }

  const handleChange = (e) => {
    const val = e.target.value;
    const name = e.target.name;

    if(name === 'toMobile'){
      const numericVal = Number(val);
      if (/^\d*$/.test(numericVal)) {
        setForm((prev) => ({ ...prev, [name]: val }));
      }
    }
    if(name === 'text_message') {
      setForm((prev) => ({ ...prev, [name]: val }));
    }
    
  }


  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-light p-3">
            <h5 className="modal-title">{"Test Device"}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
					<form onSubmit={handleSubmit} 
					className={`tablelist-form needs-validation ${validated ? "was-validated" : ""}`}
					noValidate
					autoComplete="off">
						<div className="modal-body">
							<div className="row">
                <div className="col-12">
                  <div className="mb-3">
                      <label className="form-label">From Mobile Number</label>
                      <input type="text" className="form-control-plaintext cursor-default bg-gray-100" value={form.fromMobile} readOnly />
                    </div>
                  </div>
								</div>
                <div className="col-12">
                  <div className="mb-6">
                    <label for="phonenumberInput" className="form-label">To Mobile Number</label>
                    <div class="input-group">
                        <span class="input-group-text" id="basic-addon1">91</span>
                        <input 
                          type="tel" 
                          name="toMobile" 
                          className="form-control" 
                          placeholder="9999999999" 
                          inputMode="numeric" 
                          pattern="[0-9]{10}"
                          id="phonenumberInput" 
                          value={form.toMobile} 
                          onChange={handleChange} 
                          required/>
                      
                        {error.toMobile && <div className="invalid-feedback">{error.toMobile}</div>}
                        </div>
                    </div>
                  </div>

								<div className="col-12  mt-3">
									<div className="mb-6">
                    <label for="exampleFormControlTextarea5" class="form-label">Text</label>
                    <textarea class="form-control" name="text_message" id="exampleFormControlTextarea5" rows="3" value={form.text_message} onChange={handleChange} required>
                    </textarea>
										{error.text_message && <div className="invalid-feedback">{error.text_message}</div>}
								  </div>
								<div className="col-lg-12 mt-4">
									<div className="text-end">
										<button type="button" className="btn btn-light me-2" onClick={onClose}>
												Close
										</button>
										<button type="submit" className="btn btn-success">Submit</button>
									</div>
								</div>
							</div>
						</div>
					</form>
        </div>
      </div>
    </div>
  )
}

TestTextMessageModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default TestTextMessageModal